import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
const messages = defineMessages({
  ssnOrAlienRequired: {
    id: 'App.EditOccupantModal.SsnOrAlienRequired',
    defaultMessage: 'SSN/TIN or Alien Registration # is required',
  },
  invalidAlienRegistration: {
    id: 'App.EditOccupantModal.InvalidAlienRegistration',
    defaultMessage: 'Invalid Alien Registration Number',
  },
  dateOfBirthRequired: {
    id: 'App.EditOccupantModal.DateOfBirthRequired',
    defaultMessage: 'Date of Birth is required',
  },
});

export default messages;
